import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-order-draft-card-single',
    templateUrl: './order-draft-card-single.component.html',
    standalone: false
})
export class OrderDraftCardSingleComponent {
    @Input() phoneNumbers: string[];
    
    showMoreNumbers: boolean = false;

    get visibleNumbers(): string[] {
        return this.phoneNumbers?.slice(0, 3) || [];
    }

    get additionalNumbers(): string[] {
        return this.phoneNumbers?.slice(3) || [];
    }

    get hasMoreNumbers(): boolean {
        return this.phoneNumbers?.length > 3;
    }

    get additionalCount(): number {
        return this.phoneNumbers?.length - 3 || 0;
    }

    get phonenumberCountForTranslation() {
        return this.phoneNumbers.length - 1;
    }

    toggleShowMore(): void {
        this.showMoreNumbers = !this.showMoreNumbers;
    }
}
